import { render, staticRenderFns } from "./EventoTest.vue?vue&type=template&id=42562e94&"
import script from "./EventoTest.vue?vue&type=script&lang=js&"
export * from "./EventoTest.vue?vue&type=script&lang=js&"
import style0 from "./EventoTest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports